module.exports = __webpack_public_path__ + "img/upload-thanhcong.76c90b28.svg";